import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {LoggedUser} from "./models/auth.models";
import {Constants} from "./models/shared.models";
import {AppConstants} from "./classes/app-costants";



@Component({ template: '' })
export abstract class BaseComponent implements OnDestroy {

  protected componentDestroyed$ = new Subject<boolean>();
  public userCorrente: LoggedUser | null = null;
  public itemsPageSize = Constants.PAGE_SIZE;
  public shortItemsPageSize = Constants.SHORT_PAGE_SIZE;

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  public get displayDateFormat(): string {
    return AppConstants.DATE_DISPLAY_FORMAT;
  }

  public get displayLiteralDateFormat(): string {
    return AppConstants.DATE_LITERAL_DISPLAY_FORMAT;
  }

  private static DefaultYearRange?: string;
  public get yearRange(): string {
    if (!BaseComponent.DefaultYearRange){
      const currentYear = new Date().getFullYear();
      BaseComponent.DefaultYearRange = `${currentYear - 80}:${currentYear}`;
    }
    return BaseComponent.DefaultYearRange;
  }

  private static BirthYearRange?: string;
  public get yearRangeBirth(): string {
    if (!BaseComponent.BirthYearRange){
      const currentYear = new Date().getFullYear();
      BaseComponent.BirthYearRange = `${currentYear - 80}:${currentYear - 18}`;
    }
    return BaseComponent.BirthYearRange;
  }
}
